import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {ScenariosCommandHandlerBase} from '@features/scenarios-core/services/handlers/scenarios-command-handler-base';

@Injectable({
  providedIn: 'root'
})
export class ManageEntitiesCommandHandler extends ScenariosCommandHandlerBase implements IPlatformCommandHandler {

  constructor( public router: Router,
               public commandService: CommandService,
               public fuseSplashScreenService: FuseSplashScreenService,
               public snackBarService: SnackBarService)  {
    super(router, commandService, fuseSplashScreenService, snackBarService);
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    if (command.fieldValues['FilterId'] && command.fieldValues['FilterId'].startsWith('SubScenarioEntities') === false) {
      command.fieldValues['FilterId'] = `ManageEntities-${command.fieldValues['ScenarioId']}`;
    }
    this.executeCommandToApi(command, handler);
    return true;
  }

}


